import { useState, useCallback } from 'react';

// Services

import OptionsService from '../services/options.service';

export default function GetCitiesByState() {
    const [getCitiesIsLoading, setGetCitiesIsLoading] = useState(false);
    const [getCitiesError, setCitiesError] = useState(null);
    const [cities, setCities] = useState([]);

    // Get the Cities by State

    const handleGetCitiesByState = useCallback(async (state) => {
        setGetCitiesIsLoading(true);
        setCitiesError(null);

        try {
            const citiesRequest = await OptionsService.getCitiesByState(state);

            setGetCitiesIsLoading(false);
            setCities(citiesRequest?.data?.data);

        } catch(error) {

            setGetCitiesIsLoading(false);
            setCitiesError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getCitiesIsLoading,
        getCitiesError,
        cities,
        handleGetCitiesByState,
        setCities,
    }
}
